import { Script, ScriptType } from "../../api/models";

export const title02 = "TB_0002";

export const textBanking02 = (): Script[] => [
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "WARNING: You have requested to stop Text Banking FTEU Service for the phone number. Once the service has been stopped for a phone number, you cannot add the service back again for the phone number.",
      },
    ],
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "If the free text message service is stopped on this phone number, you will no longer receive free text messages on this phone number.",
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue: "Are you sure you would like me to cancel the service?",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "If Yes: Click the Yes, Stop button.",
      },
    ],
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "If No: Click the Cancel button.",
      },
    ],
  },
];

export const title03 = "TB_0003";

export const textBanking03 = (): Script[] => [
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "Free text messaging has been stopped for this phone number. You will not receive any more free text messages to this phone number from the Bank.",
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue: "Is there anything else I can help you with?",
  },
];

export const title30051 = "TB_30051";

export const textBanking30051 = (): Script[] => [
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "WARNING: You have requested to stop Fraud Alerts Service for the phone number. Once the service has been stopped for a phone number, you cannot add the service back again for the phone number.",
      },
    ],
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "If the Fraud Alerts Service is stopped on this phone number, you will no longer receive those messages on this phone number.",
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue: "Are you sure you would like me to cancel the service?",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "If Yes: Click the Yes, Stop button.",
      },
    ],
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "If No: Click the Cancel button.",
      },
    ],
  },
];

export const title30052 = "TB_30052";

export const textBanking30052 = (): Script[] => [
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "Fraud Alerts has been stopped for this phone number. You will not receive any more of these messages to this phone number from the Bank.",
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue: "Is there anything else I can help you with?",
  },
];
